import React from 'react'
import './stylesheets/invitationCode.scss'

export default class InvitationCode extends React.Component {
  render () {
    return (
      <div className="invitation-code">
        {this.props.code}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/invitationCode.js